function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 140 140",
  width: "140",
  height: "140"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.917 43.75l5.833 52.5-5.833 35M8.75 96.25h23.333a5.833 5.833 0 015.834 5.833v29.167M137.083 43.75l-5.833 52.5 5.833 35M131.25 96.25h-23.333a5.833 5.833 0 00-5.834 5.833v29.167M26.25 67.083h87.5M70 67.083v52.5M90.096 131.25a23.14 23.14 0 00-40.192 0M61.25 32.083a13.37 13.37 0 01-11.667 14.584 13.37 13.37 0 01-11.666-14.584zM49.583 46.667v20.416M102.083 67.083H78.75v-29.75a17.372 17.372 0 012.917-9.625 17.372 17.372 0 002.916-9.625v-6.416A2.917 2.917 0 0187.5 8.75h5.833a2.917 2.917 0 012.917 2.917v6.416a17.372 17.372 0 002.917 9.625 17.372 17.372 0 012.916 9.625z",
  strokeWidth: "5.83333"
}))));